import { render, staticRenderFns } from "./CheckboxCustomFields.vue?vue&type=template&id=e99bdff2&"
import script from "./CheckboxCustomFields.vue?vue&type=script&lang=js&"
export * from "./CheckboxCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports